import { createI18n } from 'vue-i18n'

// 导入语言包
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

console.log('[TP_I18N] 国际化系统初始化')

// 支持的语言列表
export const SUPPORT_LOCALES = [
  {
    name: '简体中文',
    value: 'zh-CN',
    flag: ''
  },
  {
    name: 'English',
    value: 'en-US',
    flag: ''
  }
]

// 语言包
const messages = {
  'zh-CN': zhCN,
  'en-US': enUS
}

// 获取默认语言
const getDefaultLocale = (): string => {
  // 1. 从localStorage获取用户设置
  const savedLocale = localStorage.getItem('tenant-portal-locale')
  if (savedLocale && SUPPORT_LOCALES.find(l => l.value === savedLocale)) {
    console.log('[TP_I18N] 使用已保存的语言设置:', savedLocale)
    return savedLocale
  }

  // 2. 从浏览器语言检测
  const browserLocale = navigator.language
  const matchedLocale = SUPPORT_LOCALES.find(
    l => l.value === browserLocale || l.value.startsWith(browserLocale.split('-')[0])
  )

  if (matchedLocale) {
    console.log('[TP_I18N] 使用浏览器语言设置:', matchedLocale.value)
    return matchedLocale.value
  }

  // 3. 默认使用中文
  console.log('[TP_I18N] 使用默认语言: zh-CN')
  return 'zh-CN'
}

// 创建i18n实例
export const i18n = createI18n({
  legacy: false, // 使用Composition API
  locale: getDefaultLocale(),
  fallbackLocale: 'zh-CN',
  messages,
  globalInjection: true, // 全局注入
  silentTranslationWarn: true // 开发环境下不显示警告
})

// 设置语言
export const setLocale = (locale: string) => {
  if (!SUPPORT_LOCALES.find(l => l.value === locale)) {
    console.warn('[TP_I18N] 不支持的语言:', locale)
    return false
  }

  console.log('[TP_I18N] 切换语言到:', locale)

  // 更新i18n实例
  i18n.global.locale.value = locale as any

  // 保存到localStorage
  localStorage.setItem('tenant-portal-locale', locale)

  // 更新HTML lang属性
  document.documentElement.lang = locale

  // 更新页面标题
  updatePageTitle()

  // 异步更新应用状态（避免循环导入）
  setTimeout(() => {
    try {
      const { useAppStore } = require('@stores/app')
      const appStore = useAppStore()
      appStore.setLanguage(locale)
    } catch (error) {
      console.warn('[TP_I18N] 更新应用状态失败:', error)
    }
  }, 0)

  return true
}

// 更新页面标题
export const updatePageTitle = () => {
  const title = i18n.global.t('app.name')
  document.title = title
}

// 获取当前语言
export const getCurrentLocale = (): string => {
  return i18n.global.locale.value
}

// 获取当前语言信息
export const getCurrentLocaleInfo = () => {
  const currentLocale = getCurrentLocale()
  return SUPPORT_LOCALES.find(l => l.value === currentLocale)
}

// 格式化消息
export const t = (key: string, values?: Record<string, unknown>) => {
  return values ? i18n.global.t(key, values) : i18n.global.t(key)
}

// 检查翻译是否存在
export const te = (key: string) => {
  return i18n.global.te(key)
}

export default i18n
